import { withRouter } from "react-router-dom";

import Wrapper from "./Wrapper";

export default withRouter(Wrapper);
